/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
// import parse from 'html-react-parser'

import { resolveSKU } from '@utils/schemaUtils'
import { findHtmlElements, getHtmlText, parseHtmlFragment } from '@utils/htmlAst'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

export function getInnerText(content) {
  const metaDescription = content?.metaDescription
  if (typeof metaDescription !== 'string') return metaDescription

  const root = parseHtmlFragment(metaDescription)
  const textContent = findHtmlElements(root, 'p').map(getHtmlText).join('')
  return textContent || metaDescription
}

export function extractImageTagfromContentBeforeTocArrayFormat(contentArray) {
  if (contentArray) {
    // Iterate over the content array to find the first image
    for (const content of contentArray) {
      if (content.__component === 'text-editor.rich-text-ck' && content?.Content) {
        const $ = cheerio.load(content.Content, null, false)
        const altPattern = /alt\s*=\s*["']?([^"'\n]+)["']?/i
        const altTextMatch = content.Content.match(altPattern)
        const img = $('img').first()

        if (img.length > 0) {
          return {
            url: img.attr('src') || '',
            alt: altTextMatch?.[1] || img.attr('alt') || '',
            width: img.attr('width') || '741',
            height: img.attr('height') || '389',
          }
        }
      }
    }
    return null // No <img> tag found in any of the content blocks
  }
  return null // contentArray is undefined
}

export const baseUrl =
  typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.host}`
    : process.env.ACKO_ENV === 'master'
      ? `${process.env.CARBON_URL}`
      : process.env.ACKO_ENV === 'prod'
        ? 'https://www.acko.com'
        : 'http://localhost:3000'

// Function to find and extract the content of the "description" tag
function findDescriptionTagContent(tagsArray) {
  if (tagsArray) {
    for (const tag of tagsArray) {
      if (tag.includes('name="description"')) {
        const startContentIndex = tag.indexOf('content="') + 'content="'.length
        const endContentIndex = tag.indexOf('"', startContentIndex)
        return tag.substring(startContentIndex, endContentIndex)
      }
    }

    return null
  }
  return null
}

export const productSnippetFunc = (content, parsedMetaDescription) => {
  const heroSection = content?.content?.filter(item => item.__component === 'relation.product-page-pwn')?.[0]?.Content
    ?.data?.attributes
  return {
    name: content?.metaTitle,
    description:
      parsedMetaDescription ||
      findDescriptionTagContent(content?.seoTags?.split('/>')) ||
      'This product is policy provided by ACKO General Insurance. It protects you against financial liability arising from incidents like accidental damages and theft',
    image: heroSection?.productWidgetHeroImageDesktop?.data?.attributes?.url, // Hero image needs to change
    url: `${baseUrl}${content?.url}`,
  }
}

const CATEGORY_FROM_URL_MAP: Array<{ pattern: RegExp; category: string }> = [
  { pattern: /\/health-insurance(?:\/|$)/i, category: 'Health Insurance' },
  { pattern: /\/car-insurance(?:\/|$)/i, category: 'Car Insurance' },
  { pattern: /\/two-wheeler-insurance(?:\/|$)/i, category: 'Bike Insurance' },
  { pattern: /\/life-insurance(?:\/|$)/i, category: 'Term Life Insurance' },
  { pattern: /\/travel-insurance(?:\/|$)/i, category: 'Travel Insurance' },
]

const deriveCategoryFromUrl = (url = '') => {
  const match = CATEGORY_FROM_URL_MAP.find(item => item.pattern.test(url))
  return match?.category || null
}

export const getAdditionalProductFields = (content, breadcrumb) => {
  const breadcrumbItems = breadcrumb?.itemListElement?.map(item => item.name) || []
  const category = deriveCategoryFromUrl(content?.url) || content?.category || breadcrumbItems[1] || null
  const subCategory = content?.subProductCategory || breadcrumbItems.at(-1) || null
  const sku = resolveSKU(category, subCategory)
  return {
    category,
    subCategory,
    sku,
  }
}

export function getReactInnerText(obj) {
  let buf = ''
  if (obj) {
    const type = typeof obj
    if (type === 'string' || type === 'number') {
      buf += obj
    } else if (type === 'object') {
      let children: any = null
      if (Array.isArray(obj)) {
        children = obj
      } else {
        const props = obj.props
        if (props) {
          children = props.children
        }
      }
      if (children) {
        if (Array.isArray(children)) {
          children.forEach(o => {
            buf += getReactInnerText(o)
          })
        } else {
          buf += getReactInnerText(children)
        }
      }
    }
  }
  return buf
}

export const decodeHTML = htmlString => {
  const parser = new DOMParser()
  // parse as 'text/html' so &lt;script&gt; => <script>
  const doc = parser.parseFromString(htmlString, 'text/html')
  // The DOMParser will create a document, and its .body.textContent is the unescaped string
  return doc?.body?.textContent || ''
}

// 2) Clean up curly quotes, non-breaking spaces, etc., inside the returned string.
export const cleanJSONLD = jsonLD => {
  if (!jsonLD) return ''
  return (
    jsonLD
      // Replace curly (smart) double-quotes with ASCII quotes
      .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
      // Replace curly (smart) single-quotes with ASCII single quotes
      .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
      // Replace non-breaking spaces with normal spaces
      .replace(/\u00A0/g, ' ')
  )
}
